import workspaceQuery from '../../queries/sales/AmazonSettlementReportItemWorkspaceQuery.graphql';
import listQuery from '../../queries/sales/AmazonSettlementReportItemListQuery.graphql';
import instanceQuery from '../../queries/sales/AmazonSettlementReportItemQuery.graphql';
import defaultQuery from '../../queries/sales/AmazonSettlementReportItemDefault.graphql';
import mutationQuery from '../../mutations/sales/AmazonSettlementReportItemMutation.graphql';
import fragment from '../../fragments/sales/AmazonSettlementReportItemFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const AmazonSettlementReportItem: EntityType = {
  type: 'AmazonSettlementReportItem',
  title: 'Amazon Settlement Exceptions',
  workspaceUrl: '/Sales/Channel/AmazonSettlementReport/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_AMAZON_SETTLEMENT_ITEM',
  operations: ALLOW_VIEW,
};

export default AmazonSettlementReportItem;
